export const defaultTheme = Object.freeze({
  token: {
    fontFamily: `-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji'`, // font family for all text
    colorPrimary: "#61BC18", // main accent color
    colorSecondaryLogo: "rgba(173, 62, 240, 1)", // secondary logo color
    colorLink: "#61BC18", // link color
    colorBgContainer: "#001529", // main background color
    colorTextPlaceholder: "rgba(255, 255, 255, 0.60)", // placeholder text color
    colorText: "rgba(255, 255, 255, 0.60)", // main text color
    colorTextQuaternary: "rgba(255, 255, 255, 0.60)", // quaternary text color
    colorTextTertiary: "#8a9198", // tertiary text color
    colorBgElevated: "#001C33", // color background of select popoup
    colorFillTertiary: "#001523", // hovered option background
    // boxShadowSecondary:"0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",//box shadow color of selcts popoup
    controlOutline: "transparent", // input outline color
    colorBorder: "#d9d9d9", // outline of default buttons (cart -/+, trash) and the counter box
    colorError: "#ff4d4f", // error color (Log Out, footer WARNING, out of stock, error texts)
    colorWarning: "#faad14", // warning color (low stock, age gate icons)
    colorErrorBg: "transparent", // error background
    colorErrorBgHover: "transparent", // error background on hover
    colorErrorBorderHover: "#ff4d4f", // error border on hover
    product_default_image_bg: "#ffffff", // product default image background
  },
  components: {
    Layout: {
      bodyBg: "#001529", // main page background
      footerBg: "#001529", // footer background
      headerBg: "#001529", // header background
      footerBorderTopColor: "rgba(255, 255, 255, 0.20)", // footer top border color
      contentBg: "#001529", // content area background
    },
    Modal: {
      contentBg: "#001529", // modal content background
      headerBg: "#001529", // modal header background
    },
    Typography: {
      mainColorText: "#FFF", // main text color
      colorPrimaryText: "#61BC18", // primary accent text color
    },
    Button: {
      algorithm: true, // enable color algorithm
      colorPrimary: "#61BC18", // primary button color
      colorLink: "#61BC18", // button link color
      defaultBg: "transparent", // default button background
      defaultColor: "#61BC18", // default button text color
      defaultActiveBorderColor: "#61BC18", // active button border color
      defaultActiveBg: "transparent", // active button background
      defaultHoverBg: "transparent", // hover button background
      colorBgContainerDisabled: "#21273E", // disabled button background
      colorTextDisabled: "rgba(255, 255, 255, 0.60)", // disabled button text color
    },
    Select: {
      colorText: "#8a9198", // select text color
      optionSelectedBg: "#001523", // background for selected option
      multipleItemBg: "#001C33", // background for multiple selected items
    },
    icons: {
      whiteIcon: "#FFF", // icon color (white)
      bgColorIcon: "#001529", // icon background color
      colorPrimaryIcon: "#61BC18", // primary icon color
      colorSwiperIcon: "#8a9198", // swiper icon color (slider's next prev icons color)
      emptyCircleIconColor: "rgba(255, 255, 255, 0.60)", // empty circle icon color
      emptyIconBoxBorderColor: "rgba(255, 255, 255, 0.60)", // empty icon box border color
      emptyIconFront: "#001528", // empty icon front color
    },
    Drawer: {
      colorBgDrawer: "#001529", // drawer background color
    },
    Card: {
      colorBgCard: "#001C33", // card background color
      cardTicketGradient:
        "linear-gradient(to bottom, #001C33 45%, #003366 100%)", // card ticket gradient background
    },
    Rate: {
      starColor: "#fadb14", // filled rating star color
      starBg: "rgba(0, 0, 0, 0.06)", // empty rating star color
    },
    Segmented: {
      trackBg: "#001C33", // segmented control track background
      itemSelectedColor: "#FFF", // selected item text color
      itemSelectedBg: "#61BC18", // selected item background color
      itemColor: "#FFF", // item text color
      itemHoverColor: "#FFF", // item text color on hover
      itemHoverBg: "rgba(255, 255, 255, 0.05)", // item background on hover
    },
    Dropdown: {
      colorText: "#8a9198", // dropdown text color
    },
    Table: {
      headerBg: "#001C33", // table header background
      headerSortHoverBg: "#001C33", // header background on sort hover
      headerSortActiveBg: "#001C33", // header background on sort active
      headerFilterHoverBg: "#001C33", // header background on filter hover
      headerSplitColor: "transparent", // header split line color
      borderColor: "#001529", // table border color
      rowHoverBg: "#001523", // row background on hover
      colorBgContainer: "#001C33", // table container background
      stickyScrollBarBg: "#001523", // sticky scrollbar background
    },
    Notification: {
      colorBgElevated: "#001C33", // notification popup background color
    },
    Status: {
      warningColor: "#E8B339", // order status pills still moving (pending, in progress, finish preparing)
      successColor: "#61BC18", // complete order status pill
      errorColor: "#ff4d4f", // canceled and failed order status pills
    },
    Slider: {
      railBg: "#001C33", // slider rail background color
      railHoverBg: "#001C33", // slider rail background on hover
      trackBgDisabled: "#bbe38a", // slider track background when disabled
    },
    List: {
      listItemBg: "#001C33", // list item background color
    },
  },
});
